import { render, staticRenderFns } from "./relatorio-prevencao-visualizar.vue?vue&type=template&id=29f479c3"
import script from "./relatorio-prevencao-visualizar.vue?vue&type=script&lang=js"
export * from "./relatorio-prevencao-visualizar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports